import * as React from 'react';
import {ChangeEvent} from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
	Button,
	Checkbox,
	Chip,
	FormControl,
	FormHelperText,
	IconButton,
	Input,
	InputLabel,
	ListItemText,
	MenuItem,
	Paper,
	Select,
	TextField,
} from "@material-ui/core";
import {KeyboardDatePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from '@material-ui/icons/Delete';
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab";
import {
	actionInvoiceDelete,
	actionInvoiceFetch,
	actionInvoiceFetchAll,
	actionInvoiceSave
} from "../../store/invoices/actions";
import {Role} from "../../models/Role";
import FileUploader from "../../core/components/FileUploader";
import {Utility} from "../../core/Utility";
import {actionActiveTabTitle, actionDeleteTab, actionSetTabState} from "../../store/tabs/actions";
import {DeleteConfirmation} from "../components/DeleteConfirmation";
import {Tab} from "../Tab";
import {Validator} from "../../core/Validator";
import {Invoice, InvoiceDescriptor, InvoiceType} from "../../models/Invoice";
import {PopupDialog} from "../../core/components/PopupDialog";
import {actionCustomerFetchAll} from "../../store/customers";
import {Customer} from "../../models/Customer";
import {PdfPreview} from "../../core/components/PdfPreview";
import {InvoicePdfTemplateDescriptor} from "../../pdftemplates/InvoicePdfTemplateDescriptor";
import {PdfTemplatePopulator} from "../../pdftemplates/PdfTemplatePopulator";
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import InvoiceItemsForm from "./InvoiceItemsForm";
import AddIcon from '@material-ui/icons/Add';
import {InvoiceItem} from "../../models/InvoiceItem";
import {t} from "../../core/localization";
import {Tenant} from "../../models/Tenant";
import {actionTenantFetchRequest} from "../../store/tenant";
import {AppConstants, FooterImage, HeaderImage} from "../../constants";
import {hr} from 'date-fns/esm/locale';
import {Contract} from "../../models/Contract";
import {actionContractFetchAll} from "../../store/contracts";
import {ProFormaInvoicePdfTemplateDescriptor} from "../../pdftemplates/ProFormaInvoicePdfTemplateDescriptor";
import InvoicesService from "../../services/InvoicesService";
import {ProgressInvoicePdfTemplateDescriptor} from "../../pdftemplates/ProgressInvoicePdfTemplateDescriptor";
import {FinalInvoicePdfTemplateDescriptor} from "../../pdftemplates/FinalInvoicePdfTemplateDescriptor";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {CloudUpload} from "@material-ui/icons";

declare var pdfMake: any;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

export interface InvoiceTabProps extends BaseTabProps{
	roles: Role[]
	tab: Tab
	customers: Customer[]
	contracts: Contract[]
	invoices: Invoice[]
	tenant: Tenant
}

export interface InvoiceTabState extends BaseTabState{
	isDeleteConfirmationDialogOpen: boolean;
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any,
	selectedCustomers: any,
	selectedContracts: any,
	selectedInvoices: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		roles: state.roles.list,
		tab: state.tabs.active,
		customers: state.customers.list,
		contracts: state.contracts.list,
		tenant: state.tenant.tenant,
		invoices: state.invoices.list
	};
}

class InvoiceTab extends BaseTab<InvoiceTabProps, InvoiceTabState> {

	constructor(props: InvoiceTabProps) {
		super(props)
		this.state = {
			isDeleteConfirmationDialogOpen: false,
			isDialogOpen: false,
			dialogText: '',
			dialogTitle: '',
			validation: { valid: true, fields: [] },
			selectedCustomers: [],
			selectedContracts: [],
			selectedInvoices: []
		}
	}

	// componentWillMount() {
	// }

	// componentWillReceiveProps(nextProps: InvoiceTabProps) {
	// }

	componentDidMount() {
		actionCustomerFetchAll()
		//todo: instead of fetching all fetch only for those related to the selected customer. Implent it onCustomerChange event
		actionContractFetchAll()
		actionInvoiceFetchAll()
		actionTenantFetchRequest(null)
		if (this.props.item.id) actionInvoiceFetch(this.props.item)

		this.setSelectedContractsState(this.props.contracts);
		this.setSelectedCustomersState(this.props.customers);
	}

	componentDidUpdate(prevProps: Readonly<InvoiceTabProps>, prevState: Readonly<InvoiceTabState>, snapshot?: any): void {

		if(!prevProps.contracts.length && this.props.contracts.length) {
			this.setSelectedContractsState(this.props.contracts);
		}
		if(!prevProps.customers.length && this.props.customers.length) {
			this.setSelectedCustomersState(this.props.customers);
		}
	}

	createPdf():InvoicePdfTemplateDescriptor {
		let pdfDescriptor: any
		let pdfPopulator = new PdfTemplatePopulator()
		let customerId = this.getItemFromTabState('customerId')

		let customer: Customer = this.props.customers.find((customer: Customer) => customer.id == customerId)

		let invoice: Invoice = this.getItemFromTabState()

		try {
			invoice = InvoicesService.calculatePriceAndVat(invoice)
		} catch (ex) {
			console.log(ex.message)
		}
		// let invoiceItems: InvoiceItem[] = this.getItemFromTabState('invoiceItems')
		// for (let item of invoiceItems) {
		// 	console.log(item)
		// 	item.calculatePriceAndVat()
		// }
		let tenant = this.props.tenant
		let invoices: Invoice[] = []
		let price = invoice.price
		let vat = invoice.vat

		switch (invoice.type) {
			case InvoiceType.ProForm:
				pdfDescriptor = new ProFormaInvoicePdfTemplateDescriptor()
				break
			case InvoiceType.Regular:
				pdfDescriptor = new InvoicePdfTemplateDescriptor()
				break
			case InvoiceType.Progress:
				pdfDescriptor = new ProgressInvoicePdfTemplateDescriptor()
				break
			case InvoiceType.Final:
				pdfDescriptor = new FinalInvoicePdfTemplateDescriptor()
				let progressInvoiceIdsString: string = this.getItemFromTabState('progressInvoiceIds') as string
				let progressInvoiceIds: string[] = progressInvoiceIdsString ? (progressInvoiceIdsString+'').split(",") : []
				invoices = this.props.invoices.filter((inv) => {
					return progressInvoiceIds.indexOf(inv.id) != -1
				})
				invoices.map(inv => {
					price -= inv.price
					vat -= inv.vat
					inv.netPrice = inv.price - inv.vat
				})
				break
			default:
				pdfDescriptor = new InvoicePdfTemplateDescriptor()
		}

		pdfPopulator.setDependency({
			number: this.getItemFromTabState('number'),
			issueDate: this.getItemFromTabState('issueDate'),
			deliveryDate: this.getItemFromTabState('deliveryDate'),
			dueDate: this.getItemFromTabState('dueDate'),
			price: price,
			vat: vat,
			priceWithoutVat: price - vat,
			invoiceItems: invoice.invoiceItems,
			customerName: customer ? customer.title : "",
			customerAddress: customer ? customer.address : "",
			customerVatId: customer ? customer.vatId : "",
			customerLegalId: customer ? customer.companyId : "",
			tenantName: tenant ? tenant.title : "",
			tenantAddress: tenant ? tenant.address : "",
			tenantVatId: tenant ? tenant.vatId : "",
			tenantCompanyId: tenant ? tenant.companyId : "",
			tenantAccountNumber: tenant ? tenant.accountNumber : "",
			tenantInvoiceText: this.getItemFromTabState('description') ? this.getItemFromTabState('description') : tenant.invoiceText ,
			tenantInvoiceBackground: tenant ? tenant.invoiceBackground : "",
			tenantInvoiceResponsible: tenant ? tenant.invoiceResponsible : "",
			footerImage: tenant && tenant.invoiceFooterImage.length > 100 ? tenant.invoiceFooterImage : FooterImage, //todo: reevaluate >100 heuristic
			headerImage: tenant && tenant.invoiceHeaderImage.length > 100 ? tenant.invoiceHeaderImage : HeaderImage,
			invoices: invoices
		})
		pdfPopulator.populateRecursively(pdfDescriptor.pdfTemplate, pdfDescriptor, '')

		return pdfDescriptor
	}

	render(): React.ReactNode {

		let invoiceType: InvoiceType = Utility.formatString(this.getItemFromTabState('type')) as InvoiceType

		if (this.props.item && this.props.tenant) {
			let pdfDescriptor = this.createPdf()
			return (
				<div style={{padding: '10px'}}>
					{this.renderTabControls()}
					<div style={{display: 'flex', flexDirection: 'row', flex: '2', marginTop: '10px'}}>
						<div style={{flex: '1', marginRight: '20px'}}>
							<Paper style={{padding: '10px'}}>
								{this.renderForm()}
								{this.renderFormControls()}
							</Paper>
							{this.props.item.id && <Paper style={{padding: '10px', marginTop: '10px'}}>
								<div>
									<Button onClick={this.addInvoiceItem.bind(this)} color="primary"
											style={{}}><AddIcon/>{t.AddService}</Button>
									<InvoiceItemsForm/>
								</div>
								{!this.props.item.id && (
									<div>{t.SaveItem}</div>
								)}
							</Paper>}
						</div>
						<div style={{flex: '1'}}>
							<Paper style={{padding: '10px'}}>
								<PdfPreview pdf={pdfDescriptor.pdfTemplate}/>
								{this.props.item.id && <FileUploader
									itemId={this.props.item.id}
									itemType={t.Invoices}
									uploads={this.props.item.uploads}
									onUpload={this.onUpload.bind(this)}
									onDelete={this.onFileDelete.bind(this)}/>}
								{!this.props.item.id && <p style={{textAlign: 'center'}}>{t.SaveItem}</p>}
							</Paper>
						</div>
					</div>
					{this.renderDeleteConfirmationDialog()}
					{this.renderPopupDialog()}
				</div>
			);
		} else {
			return <div>Učitavanje podataka</div>
		}
	}

	renderForm(): React.ReactNode {

		let invoiceType: InvoiceType = Utility.formatString(this.getItemFromTabState('type')) as InvoiceType
		let progressInvoiceIdsString: string = this.getItemFromTabState('progressInvoiceIds') as string
		let progressInvoiceIds: string[] = progressInvoiceIdsString ? (progressInvoiceIdsString+'').split(",") : []

		let customers = this.props.customers;
		if(this.state.selectedCustomers && this.state.selectedCustomers.length !== 0) {
			customers = this.state.selectedCustomers;
		}

		let selectedCustomer: Customer[] = [];
		let customerId = this.getItemFromTabState('customerId')
		if(!Utility.isNullOrUndefined(customerId)) {
			selectedCustomer = this.props.customers.filter(x => x.id === customerId)
		}


		return <form className='ev-form' noValidate autoComplete="on">
				<FormControl required style={{width: '100%'}} >
					<InputLabel htmlFor="age-required">{'Tip'}</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('type'))}
						onChange={(e) => {this.handleItemSelectChange(e, 'type')}}
						name="type"
						required={false}
						error={Validator.displayFormErrors(this.state.validation.fields, 'type').show}
						style={{width: '100%'}}>
						<MenuItem key={InvoiceType.ProForm} value={InvoiceType.ProForm}>Predračun</MenuItem>
						<MenuItem key={InvoiceType.Regular} value={InvoiceType.Regular}>Račun</MenuItem>
						<MenuItem key={InvoiceType.Progress} value={InvoiceType.Progress}>Avansni račun</MenuItem>
						<MenuItem key={InvoiceType.Final} value={InvoiceType.Final}>Finalni račun</MenuItem>
					</Select>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'contractId').message}</FormHelperText>
				</FormControl>
				<TextField
					label={t.Number}
					value={Utility.formatString(this.getItemFromTabState('number'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'number')}}
					margin="normal"
					fullWidth
					required={true}
					error={Validator.displayFormErrors(this.state.validation.fields, 'number').show}
					helperText={Validator.displayFormErrors(this.state.validation.fields, 'number').message}
				/>
				<TextField
					label={t.Description}
					value={Utility.formatString(this.getItemFromTabState('description') == null ? this.props.tenant.invoiceText : this.getItemFromTabState('description'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'description')}}
					margin="normal"
					fullWidth
					multiline
				/>
				<MuiPickersUtilsProvider utils={DateFnsUtils} locale={hr}>
					<KeyboardDatePicker
						margin="normal"
						id="date-picker-dialog"
						label={t.InvoiceDate}
						format={Utility.PICKER_DATE_FORMAT}
						value={Utility.formatDateString(this.getItemFromTabState('issueDate'))}
						onChange={(e) => {this.handleItemDateChange(e, 'issueDate')}}
						onBlur={null}
						onFocus={null}
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'issueDate').show}
						KeyboardButtonProps={{
							'aria-label': 'change paymentDate',
						}}
						style={{marginRight: '10px'}}
					/>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'issueDate').message}</FormHelperText>
					<KeyboardDatePicker
						margin="normal"
						id="date-picker-dialog"
						label={t.SupplyDate}
						format={Utility.PICKER_DATE_FORMAT}
						value={Utility.formatDateString(this.getItemFromTabState('deliveryDate'))}
						onChange={(e) => {this.handleItemDateChange(e, 'deliveryDate')}}
						onBlur={null}
						onFocus={null}
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'deliveryDate').show}
						KeyboardButtonProps={{
							'aria-label': 'change paymentDate',
						}}
						style={{marginRight: '10px'}}
					/>
					<FormHelperText color="primary">{Validator.displayFormErrors(this.state.validation.fields, 'deliveryDate').message}</FormHelperText>
					<KeyboardDatePicker
						margin="normal"
						id="date-picker-dialog"
						label={t.DueDate}
						format={Utility.PICKER_DATE_FORMAT}
						value={Utility.formatDateString(this.getItemFromTabState('dueDate'))}
						onChange={(e) => {this.handleItemDateChange(e, 'dueDate')}}
						onBlur={null}
						onFocus={null}
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'dueDate').show}
						KeyboardButtonProps={{
							'aria-label': 'change paymentDate',
						}}
					/>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'dueDate').message}</FormHelperText>
				</MuiPickersUtilsProvider>
				{/*<FormControl required style={{width: '100%'}} >*/}
				{/*	<InputLabel htmlFor="age-required">{t.Customer}</InputLabel>*/}
				{/*	<Select*/}
				{/*		value={Utility.formatString(this.getItemFromTabState('customerId'))}*/}
				{/*		onChange={(e) => {this.handleCustomersSelectChange(e, 'customerId')}}*/}
				{/*		name="customerId"*/}
				{/*		required={true}*/}
				{/*		error={Validator.displayFormErrors(this.state.validation.fields, 'customerId').show}*/}
				{/*		style={{width: '100%'}}>*/}
				{/*		{this.state.selectedCustomers.sort(Utility.compareForSorting('title')).map((component: any, key: number) => (*/}
				{/*			<MenuItem key={key} value={component.id}>{component.title}</MenuItem>*/}
				{/*		))}*/}
				{/*	</Select>*/}
				{/*	<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'customerId').message}</FormHelperText>*/}
				{/*</FormControl>*/}
				<FormControl required style={{width: '100%'}} >
					<Autocomplete
						options={customers.sort(Utility.compareForSorting('title'))}
						getOptionLabel={(option: any) => option.title}
						getOptionSelected={(option, value) => option.id === value.id}
						style={{ width: '100%' }}
						value={selectedCustomer[0]}
						onChange={(e: object, value: any | null) => this.handleCustomersAutocompleteChange(value, 'customerId')}
						renderInput={(params) => <TextField {...params} label={t.Customer} margin="normal" required={true} />}
					/>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'customerId').message}</FormHelperText>
				</FormControl>
				<FormControl required style={{width: '100%'}} >
					<InputLabel htmlFor="age-required">{'Ugovor'}</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('contractId'))}
						onChange={(e) => {this.handleContractsSelectChange(e, 'contractId')}}
						name="contractId"
						error={Validator.displayFormErrors(this.state.validation.fields, 'contractId').show}
						style={{width: '100%'}}>
						{/*<MenuItem key="allContracts" value=''>{t.All}</MenuItem>*/}
						{this.state.selectedContracts.map((component: any, key: number) => (
							<MenuItem key={key} value={component.id}>{component.number + ' - ' + component.title}</MenuItem>
						))}
					</Select>
					<FormHelperText>{Validator.displayFormErrors(this.state.validation.fields, 'contractId').message}</FormHelperText>
				</FormControl>
				{invoiceType == InvoiceType.Final && <FormControl style={{width: '100%'}}>
					<InputLabel id="demo-mutiple-chip-label">{'Povezni avansni računi'}</InputLabel>
					<Select
						id="demo-mutiple-chip"
						multiple
						value={progressInvoiceIds}
						onChange={(e) => {this.handleProgressInvoicesSelectChange(e, 'progressInvoiceIds')}}
						input={<Input id="select-multiple-chip" />}
						renderValue={(selected: any) => (
							<div >
							{selected.map((invoiceId: any) => {
								let invoice = this.props.invoices.find((item) => item.id == invoiceId)
								return (<Chip key={`progress-invoice-chip-${invoice.id}`} label={`${invoice.number} - ${Utility.formatDate(invoice.issueDate)}`}/>)
							})}
							</div>
							)}
						MenuProps={MenuProps}
					>
						{this.props.invoices.filter(invoice => invoice.type == InvoiceType.Progress && invoice.customerId == this.getItemFromTabState('customerId')).map((invoice) => (
							<MenuItem key={`progress-invoice-${invoice.id}`} value={`${invoice.id}`} >
								<Checkbox checked={progressInvoiceIds && progressInvoiceIds.indexOf(invoice.id) > -1} />
								<ListItemText primary={`${invoice.number} - ${Utility.formatDate(invoice.issueDate)}`} />
							</MenuItem>
						))}
					</Select>
				</FormControl>}
		</form>;
	}

	renderFormControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderTabControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={this.openDeleteConfirmationModal.bind(this)}>
				<DeleteIcon />
			</IconButton>
			<IconButton
				aria-label="more"
				aria-controls="long-menu"
				aria-haspopup="true"
				onClick={this.onDownloadClick.bind(this)}>
				<GetAppRoundedIcon />
			</IconButton>
			<Button variant="contained" color="primary"><CloudUpload /> E-faktura</Button>
		</div>
	}

	renderDeleteConfirmationDialog(): React.ReactNode {
		return <DeleteConfirmation
			isOpen={this.state.isDeleteConfirmationDialogOpen}
			onDeleteConfirm={() => this.onDeleteConfirmClick()}
			onToggleModal={() => this.onToggleDeleteConfirmationModal()}
		/>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onDownloadClick() {
		let pdfDescriptor = this.createPdf()
		let pdfMakeDocument = pdfMake.createPdf(pdfDescriptor.pdfTemplate),
			number = Utility.formatString(this.getItemFromTabState('number')).replace(' ', '_'),
			fileName =  `invoice_${number}.pdf`;
		pdfMakeDocument.download(fileName);
	}

	onSaveClick () {

		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, InvoiceDescriptor)

		if (validation.valid) {
			actionInvoiceSave(itemToSave)
			actionActiveTabTitle(t.Invoice + ': ' + itemToSave.number)
		}

		this.setState({ ...this.state, validation: validation });
	}

	onUpload () {
		actionInvoiceFetch(this.props.item)
	}

	onFileDelete () {
		actionInvoiceFetch(this.props.item)
	}

	openDeleteConfirmationModal() {
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: true});
	}

	onToggleDeleteConfirmationModal(){
		this.setState({ ...this.state, isDeleteConfirmationDialogOpen: !this.state.isDeleteConfirmationDialogOpen});
	}

	onDeleteConfirmClick(){
		actionInvoiceDelete(this.props.item)
		actionDeleteTab(this.props.tab)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	addInvoiceItem(){
		let item = this.getItemFromTabState()

		if(item){
			if(!item['invoiceItems']){
				item['invoiceItems'] = []
				//item['selectedInvoiceItemNumber'] = undefined
			}

			item['selectedInvoiceItemNumber'] = item['invoiceItems'].length

			let invoiceItem = new InvoiceItem()
			invoiceItem.customerId = item.customerId
			invoiceItem.invoiceId = this.props.item.id
			invoiceItem.vat = AppConstants.vatValue

			item['invoiceItems'].push(invoiceItem)

			let tabState = this.props.state
			tabState['item'] = item
			actionSetTabState(tabState)
		}
	}

	// protected handleCustomersSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, name: string) {
	//
	// 	let selectedCustomerId = e.target.value;
	// 	let contracts = Utility.clone(this.props.contracts);
	//
	// 	let selectedContracts = contracts.filter((contract: any) => {
	// 		return contract.customerId === selectedCustomerId;
	// 	});
	//
	// 	// change contracts select state
	// 	this.setState({ selectedContracts: selectedContracts });
	//
	// 	let item: any = this.props.item;
	// 	let tabState = this.props.state;
	// 	if (!tabState['item']) tabState['item'] = Utility.clone(item);
	// 	tabState['item']['contractId'] = '';
	// 	tabState['item']['customerId'] = selectedCustomerId;
	//
	// 	// change tab state
	// 	actionSetTabState(tabState);
	// }

	protected handleCustomersAutocompleteChange(value: any, name: string) {

		if(value && value.id) {

			let selectedCustomerId = value.id;

			let contracts = Utility.clone(this.props.contracts);

			let selectedContracts = contracts.filter((contract: any) => {
				return contract.customerId === selectedCustomerId;
			});

			// change contracts select state
			this.setState({ selectedContracts: selectedContracts });

			let item: any = this.props.item;
			let tabState = this.props.state;
			if (!tabState['item']) tabState['item'] = Utility.clone(item);
			tabState['item']['contractId'] = '';
			tabState['item']['customerId'] = selectedCustomerId;

			// change tab state
			actionSetTabState(tabState);
		}
	}

	protected handleContractsSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, name: string) {

		let item: any = this.props.item;
		let tabState = this.props.state;
		if (!tabState['item']) tabState['item'] = Utility.clone(item);

		let val = e.target.value;
		let contracts = Utility.clone(this.props.contracts);
		let selectedContractId: any = '';
		let selectedCustomerId: any = '';

		if(val !== '') {

			selectedContractId = val;

			let customersByContract = contracts.filter((contract: any) => {
				return contract.id === val;
			});

			if(customersByContract && Object.keys(customersByContract).length) {
				selectedCustomerId = customersByContract[0].customerId;
			}
		}
		else{
			this.setState({ selectedContracts: contracts });
		}

		if(tabState.item.customerId !== selectedCustomerId) {
			tabState['item']['customerId'] = selectedCustomerId;
		}
		tabState['item']['contractId'] = selectedContractId;
		actionSetTabState(tabState);
	}

	protected handleProgressInvoicesSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, name: string) {

		let item: any = this.props.item;
		let tabState = this.props.state;
		if (!tabState['item']) tabState['item'] = Utility.clone(item);
		let progressInvoiceIds = e.target.value as string[]
		let progressInvoiceIdsString = progressInvoiceIds.join(",")
		tabState['item']['progressInvoiceIds'] = progressInvoiceIdsString;
		actionSetTabState(tabState);
	}

		getSelectedContracts() {

		let item: any = this.props.item;
		let contracts = Utility.clone(this.props.contracts);
		let customerId: any = item.customerId;

		let selectedContracts = contracts;

		if(customerId && customerId !== 'all') {

			selectedContracts = contracts.filter((contract: any) => {
				return contract.customerId === customerId;
			});
		}

		return selectedContracts;
	}

	setSelectedCustomersState(customers: any) {

		if(customers.length) {

			let customers = Utility.clone(this.props.customers);

			if(this.state.selectedCustomers.lenght) {
				customers = Utility.clone(this.state.selectedCustomers);
			}

			this.setState({ selectedCustomers: customers });
		}
	}

	setSelectedContractsState(contracts: any) {

		if(contracts.length) {

			let selectedContracts = this.getSelectedContracts();

			this.setState({ selectedContracts: selectedContracts });
		}
	}
}

export default connect(mapStateToProps)(InvoiceTab);
